import { useTranslation } from "react-i18next";
import { MobileCardRow, MobileCardWrapper, TableBody, TableColumn, TableHeader, TableRow, TableCell } from "./dashboard/table-components";
import { useMediaQuery } from '@mui/material';
import { formatDate } from '../helper/common.helper';
import { useStatements } from '../hooks/useStatements';
import { YearFilter } from './common/YearFilter';
import SkeletonLoading from './SkeletonLoading';
import './../scss/components/invoice-table-detailed.style.scss';
import { DownloadIcon } from "../assets/dashboard-icon.svg";

export const StatementsInvoiceSection = () => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const {
        statements,
        loading,
        error,
        handleYearChange,
        selectedYear
    } = useStatements();
    return (
        <>
            <YearFilter
                onYearChange={handleYearChange}
                initialYear={selectedYear}
                label={t('YEAR_LABEL')}
                className="statements-year-filter"
                loading={loading}
            />
            <div className={`invoice-table-container my-4`}>
                <div className="invoice-table-content">
                    <div className="invoice-table">

                        <>
                            {!isMobile && (
                                <TableHeader>
                                    {[t('SALARY_IN_') + selectedYear, t('TAX_IN_') + selectedYear, t('SOCIAL_FEE_IN_') + selectedYear, t('GROSS_SALARY_INC_HOLIDAY_PAY_IN') + selectedYear].map((header, index) => (
                                        <TableColumn key={index}>{header}</TableColumn>
                                    ))}
                                </TableHeader>
                            )}

                            <TableBody>
                                {loading ? (
                                    <SkeletonLoading />
                                ) : statements === null ? (
                                    <div className="invoice-table">
                                        <div className="invoice-table-content">
                                            {/* No data found message */}
                                            <div className='d-flex justify-content-center flex-column align-items-center pt-5'>
                                                <span className='pt-3'>{t('NO_DATA_FOUND')}.</span>
                                                {error}
                                            </div>
                                        </div>
                                    </div>
                                ) : isMobile ? (
                                    // Mobile: Card-based layout
                                    ([statements].map((value, index) =>
                                        <MobileCardWrapper key={index}>
                                            <MobileCardRow label={t('SALARY_IN_') + selectedYear} >
                                                {value?.salary} {t('kr')}
                                            </MobileCardRow>
                                            <MobileCardRow label={t('TAX_IN_') + selectedYear}>
                                                {value?.totalTax} {t('kr')}
                                            </MobileCardRow>
                                            <MobileCardRow label={t('SOCIAL_FEE_IN_') + selectedYear}>
                                                {value?.socialFee} {t('kr')}
                                            </MobileCardRow>
                                            <MobileCardRow label={t('GROSS_SALARY_INC_HOLIDAY_PAY_IN') + selectedYear}>
                                                {value?.grossSalary} {t('kr')}
                                            </MobileCardRow>
                                            {/* <MobileCardRow label={t('ACTION_LABEL')}>
                                                    <DownloadIcon />
                                                </MobileCardRow> */}
                                        </MobileCardWrapper>
                                    ))
                                ) : (
                                    [statements].map((value, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{value?.salary} {t('kr')}</TableCell>
                                            <TableCell>{value?.totalTax} {t('kr')}</TableCell>
                                            <TableCell>{value?.socialFee} {t('kr')}</TableCell>
                                            <TableCell>{value?.grossSalary} {t('kr')}</TableCell>
                                            {/* <TableCell>
                                                    <DownloadIcon />
                                                </TableCell> */}
                                        </TableRow>
                                    ))
                                )}

                            </TableBody>
                        </>
                    </div>
                </div>
            </div>
        </>
    )
};